import { render, staticRenderFns } from "./goodsBack.vue?vue&type=template&id=837da4ca&scoped=true&"
import script from "./goodsBack.vue?vue&type=script&lang=js&"
export * from "./goodsBack.vue?vue&type=script&lang=js&"
import style0 from "./goodsBack.vue?vue&type=style&index=0&id=837da4ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837da4ca",
  null
  
)

export default component.exports